import axios from '@!/lib/axios'
import { getCsrfToken } from '@!/Util/postRequest'

export const loginEmailApi = async (email, password) => {
  return await axios.post(
    '/external_payment_api/v1/auth/login_email',
    {
      email,
      password,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': getCsrfToken(),
      },
    },
  )
}

export const saveMemberApi = async () => {
  return await axios.post(
    '/external_payment_api/v1/credit/save_member',
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': getCsrfToken(),
      },
    },
  )
}

export const searchCardApi = async () => {
  return await axios.post(
    '/external_payment_api/v1/credit/search_card',
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': getCsrfToken(),
      },
    },
  )
}

export const payWithPayPayApi = async (productId) => {
  return await axios.post(
    '/external_payment_api/v1/purchase/coin/pay_with_paypay',
    { product_id: productId },
    {
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': getCsrfToken(),
      },
    },
  )
}

export const saveCardApi = async (token, isUpdate = false) => {
  return await axios.post(
    '/external_payment_api/v1/credit/save_card',
    {
      token,
      is_update: isUpdate,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': getCsrfToken(),
      },
    },
  )
}

export const payWithCreditCardApi = async (productId) => {
  return await axios.post(
    '/external_payment_api/v1/purchase/coin/pay_with_credit',
    { product_id: productId },
    {
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': getCsrfToken(),
      },
    },
  )
}

export const logoutApi = async () => {
  return await axios.delete('/external_payment_api/v1/auth/logout', {
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
  })
}
